import React from "react";
import { Badge } from "flowbite-react";
import { X as XIcon, ArrowCounterClockwise } from "@phosphor-icons/react";

export interface ActiveFilter {
  id: string;
  label: string;
  icon?: React.ReactNode;
  onClear: () => void;
}

interface FilterSummaryProps {
  filters: ActiveFilter[];
  onClearAll: () => void;
  title?: string;
  clearAllLabel?: string;
}

const FilterSummary: React.FC<FilterSummaryProps> = ({
  filters,
  onClearAll,
  title = "Applied Filters",
  clearAllLabel = "Clear All",
}) => {
  if (filters.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 px-4 py-2 bg-gray-50/50 dark:bg-neutral-800/60 rounded-xl border border-gray-100 dark:border-neutral-700">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm font-medium text-gray-500 dark:text-gray-400 mr-2">{title}:</span>
        <div className="flex flex-wrap items-center gap-2">
          {filters.map((filter) => (
            <Badge
              key={filter.id}
              color="gray"
              size="sm"
              className="pl-1 pr-2 py-1 flex items-center gap-1 group bg-white dark:bg-neutral-700 border border-gray-200 dark:border-neutral-600 text-gray-700 dark:text-gray-200"
            >
              <div className="flex items-center gap-1.5">
                {filter.icon && (
                  <div className="flex items-center shrink-0">
                    {filter.icon}
                  </div>
                )}
                <span className="max-w-[150px] truncate text-xs font-medium">
                  {filter.label}
                </span>
                <button
                  onClick={filter.onClear}
                  className="p-0.5 hover:bg-gray-100 dark:hover:bg-neutral-600 rounded-full transition-colors ml-1 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300"
                  title={`Clear ${filter.label}`}
                >
                  <XIcon size={12} weight="bold" />
                </button>
              </div>
            </Badge>
          ))}
        </div>
      </div>

      <button
        onClick={onClearAll}
        className="text-sm font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 flex items-center gap-2 px-3 py-1.5 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-lg transition-all"
      >
        <ArrowCounterClockwise size={16} weight="bold" />
        <span>{clearAllLabel}</span>
      </button>
    </div>
  );
};

export default FilterSummary;
